var exports = {
  "kL": "x4ddf2309--8369c0--container",
  "Sl": "x4ddf2309--8369c0--image",
  "h_": "x4ddf2309--8369c0--description",
};

module.exports = exports;
